<!-- 
	This is the tables page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <!-- Authors Table -->
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <!-- Authors Table Card -->
        <CardAuthorTable
          :data="table1Data"
          :columns="table1Columns"
          @getUsers="getUsers"
        ></CardAuthorTable>
        <!-- / Authors Table Card -->
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>
    <!-- / Authors Table -->

    <!-- Projects Table -->
    <!-- <a-row :gutter="24" type="flex">

			<a-col :span="24" class="mb-24">
				<CardProjectTable2
					:data="table2Data"
					:columns="table2Columns"
				></CardProjectTable2>

			</a-col>
		</a-row> -->
    <!-- / Projects Table -->
  </div>
</template>

<script>
import { userlist } from "@/api/user";
// "Authors" table component.
import CardAuthorTable from "./components/CardAuthorTable";

// "Projects" table component.
import CardProjectTable2 from "./components/CardProjectTable2";

// "Authors" table list of columns and their properties.
const table1Columns = [
  {
    title: "账号",
    dataIndex: "username",
    scopedSlots: { customRender: "username" },
    width: 210,
  },
  {
    title: "账号类型",
    dataIndex: "role",
    scopedSlots: { customRender: "accountType" },
    width: 100,
  },
  {
    title: "套餐",
    dataIndex: "plan_name",
    scopedSlots: { customRender: "plan" },
    width: 100,
  },
  {
    // 主账号:今日用量/套餐日额度进度条;子账号:其授权域名今日用量(额度扣在主账号)
    title: "今日用量",
    dataIndex: "used_today",
    scopedSlots: { customRender: "usage" },
    width: 220,
  },
  {
    title: "父账号",
    dataIndex: "parent",
    scopedSlots: { customRender: "parent" },
    width: 130,
  },
  {
    // 域名列收起：默认只展示前几个，多余折叠为「+N」气泡，避免列过宽把操作列挤出屏
    title: "域名",
    dataIndex: "website",
    scopedSlots: { customRender: "website" },
    width: 200,
  },
  {
    title: "到期时间",
    dataIndex: "expiry_time",
    scopedSlots: { customRender: "expiry_time" },
    width: 140,
  },
  {
    title: "操作",
    scopedSlots: { customRender: "editBtn" },
    width: 280,
  },
];

// "Projects" table list of columns and their properties.
const table2Columns = [
  {
    title: "COMPANIES",
    dataIndex: "company",
    scopedSlots: { customRender: "company" },
    width: 300,
  },
  {
    title: "BUDGET",
    dataIndex: "budget",
    class: "font-semibold text-muted",
  },
  {
    title: "STATUS",
    dataIndex: "status",
    class: "font-semibold text-muted text-sm",
  },
  {
    title: "COMPLETION",
    scopedSlots: { customRender: "completion" },
    dataIndex: "completion",
  },
  {
    title: "",
    scopedSlots: { customRender: "editBtn" },
    width: 50,
  },
];

// "Projects" table list of rows and their properties.
const table2Data = [
  {
    key: "1",
    company: {
      name: "Spotify Version",
      logo: "images/logos/logo-spotify.svg",
    },
    status: "working",
    budget: "$14,000",
    completion: 60,
  },
  {
    key: "2",
    company: {
      name: "Progress Track",
      logo: "images/logos/logo-atlassian.svg",
    },
    status: "working",
    budget: "$3,000",
    completion: 10,
  },
  {
    key: "3",
    company: {
      name: "Jira Platform Errors",
      logo: "images/logos/logo-slack.svg",
    },
    status: "done",
    budget: "Not Set",
    completion: {
      status: "success",
      value: 100,
    },
  },
  {
    key: "4",
    company: {
      name: "Launch new Mobile App",
      logo: "images/logos/logo-spotify.svg",
    },
    status: "canceled",
    budget: "$20,600",
    completion: {
      status: "exception",
      value: 50,
    },
  },
  {
    key: "5",
    company: {
      name: "Web Dev",
      logo: "images/logos/logo-webdev.svg",
    },
    status: "working",
    budget: "$4,000",
    completion: 80,
  },
  {
    key: "6",
    company: {
      name: "Redesign Online Store",
      logo: "images/logos/logo-invision.svg",
    },
    status: "canceled",
    budget: "$2,000",
    completion: {
      status: "exception",
      value: 0,
    },
  },
];

export default {
  components: {
    CardAuthorTable,
    CardProjectTable2,
  },
  data() {
    return {
      // Associating "Authors" table data with its corresponding property.
      table1Data: [],

      // Associating "Authors" table columns with its corresponding property.
      table1Columns: table1Columns,

      // Associating "Projects" table data with its corresponding property.
      table2Data: table2Data,

      // Associating "Projects" table columns with its corresponding property.
      table2Columns: table2Columns,
    };
  },
  methods: {
    getUsers() {
      userlist().then((res) => {
        this.table1Data = res.data.map((user) => {
          if (Array.isArray(user.website)) {
            user.website = user.website.join(",");
          }
          return user;
        });
      });
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>

<style lang="scss">
</style>